<template>
    <div>
        <OcorrenciaInfo :idOcorrencia="idOcorrencia" @setActionCard="setActionCard" :isFinalizado="ocorrencia.flFinalizado" />
        <div class="container-fluid">
            <div class="d-flex">
                <div class="flex-grow-1">
                    <InputSearch v-model="filtro_text" placeholder="Pesquisar por Nome Unidade de Compra, ou Nome Pessoa..." @updateSearch="getFiltros" @keypress.enter="performSearch" />
                </div>
                <div class="ms-2">
                    <button class="btn btn-new-crud" v-on:click="newLocalizador">
                        <i class="fas fa-regular fa-plus"></i><span class="ms-2">Gerar Novo Localizador</span>
                    </button>
                </div>
            </div>
            <div class="row mt-3">
                <div v-if="inscricoes.length == 0">
                    <Card_Title :class_color="'bg-color-4'">
                        <template v-slot:context>
                            <div class="row">
                                <strong>Nenhum Localizador Gerado.</strong>
                            </div>
                        </template>
                    </Card_Title>
                </div>
                <div v-for="inscricao in inscricoes" :key="inscricao.idInscricao" v-else>
                    <Card_Title :class_color="'bg-color-4'">
                        <template v-slot:context>
                            <div class="row">
                                <div class="col">
                                    <ul class="list-group">
                                        <li class="list-group-item">
                                            <div class="d-flex align-items-center">
                                                <label class="form-label" style="font-size: 16px;">Inscrição - {{ inscricao.cdLocalizador }}</label>
                                                <button class="btn-grid-editar-lista-v2 ms-auto" type="button" v-on:click="ConfirmaEnviaEmailInscricao(inscricao.idInscricao, inscricao.dsEmailResponsavel)" style="font-size: 10px;">
                                                    <i class="fas fa-paper-plane"></i><span class="ms-1">Enviar Link Responsável</span>
                                                </button>
                                            </div>
                                            <div><label><strong>Qtd Participantes:</strong> {{ inscricao.qtdParticipantes }}</label></div>
                                            <div><label><strong>Nome:</strong> {{ inscricao.nmNome }}</label></div>
                                            <div v-if="inscricao.tpInstituicao == 'F'">
                                                <label><strong>CPF:</strong> {{ inscricao.nrCpfCnpj }}</label>
                                                <label><strong>E-mail:</strong> {{ inscricao.dsEmail }}</label>
                                            </div>
                                            <div v-else><label><strong>CNPJ:</strong> {{ inscricao.nrCpfCnpj }}</label></div>
                                            <div><label><strong>Telefone:</strong> {{ inscricao.nrTelefone }} | <strong>Celular:</strong> {{ inscricao.nrCelular }}</label></div>
                                            <div><label><strong>Endereço:</strong> {{ inscricao.dsEndereco }} {{ inscricao.nrNumero }} {{ inscricao.dsComplemento }} {{ inscricao.nmBairro }} {{ inscricao.nmCidade }} {{ inscricao.nmUf }}</label></div>
                                            <div v-if="inscricao.tpInstituicao == 'J'">
                                                <div class="row">
                                                    <div class="col">
                                                        <label class="form-label mt-3" style="        font-size: 14px;">Responsável</label>
                                                        <div><label><strong>Nome:</strong> {{ inscricao.nmNomeResponsavel }}</label></div>
                                                        <div><label><strong>E-mail:</strong> {{ inscricao.dsEmailResponsavel }}</label></div>
                                                        <div><label><strong>Telefone:</strong> {{ inscricao.nrTelefoneResponsavel }}</label></div>
                                                        <div><label><strong>Celular:</strong> {{ inscricao.nrCelularResponsavel }}</label></div>
                                                        <div><label><strong>Departamento:</strong> {{ inscricao.nmDepartamentoResponsavel }}</label></div>
                                                        <div><label><strong>Função:</strong> {{ inscricao.nmFuncaoResponsavel }}</label></div>
                                                    </div>
                                                    <div class="col">
                                                        <label class="form-label mt-3" style="        font-size: 14px;">Financeiro</label>
                                                        <div><label><strong>Nome:</strong> {{ inscricao.nmNomeFinanceiro }}</label></div>
                                                        <div><label><strong>E-mail:</strong> {{ inscricao.dsEmailFinanceiro }}</label></div>
                                                        <div><label><strong>Telefone:</strong> {{ inscricao.nrTelefoneFinanceiro }}</label></div>                                                        
                                                        <div><label><strong>Celular:</strong> {{ inscricao.nrCelularFinanceiro }}</label></div>
                                                        <div><label><strong>Departamento:</strong> {{ inscricao.nmDepartamentoFinanceiro }}</label></div>
                                                        <div><label><strong>Função:</strong> {{ inscricao.nmFuncaoFinanceiro }}</label></div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="row">
                                                <div class="col">
                                                    <label class="form-label mt-3" style="font-size: 14px;">Proposta</label>
                                                    <div class="input-group">                                                       
                                                        <div><label>Número e Ano: <strong>{{ inscricao.nrProposta }}/{{ inscricao.nrAno }}</strong></label></div>
                                                    </div>
                                                </div>

                                                <div class="col">
                                                    <label class="form-label mt-3" style="font-size: 14px;">Processo</label>
                                                    <div class="input-group">
                                                        <div><label>Etapa: <strong>{{ inscricao.nmEtapa }}</strong></label></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>

                                <div class="col">
                                    <ul class="list-group">
                                        <li class="list-group-item">
                                            <label class="form-label" style="        font-size: 16px;">Participantes - ({{ inscricao.qtdParticipantes }} / {{ inscricao.participantes.length }})</label>
                                            <div v-if="inscricao.participantes.length == 0">
                                                <strong>Nenhum Passaporte Gerado.</strong>
                                            </div>
                                            <div v-for="participante in inscricao.participantes" :key="participante.idParticipante">
                                                <label class="form-label mt-2" style="        font-size: 14px;">Passaporte - {{ participante.cdPassaporte }}</label>

                                                <div class="mb-2">
                                                    <img v-if="participante.urlFoto != '' && participante.urlFoto != null" :src="participante.urlFoto" height="80" width="80" class="rounded">
                                                    <img v-else src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRR2v_7kEUKeNc8AvCMMX5MYE6cRoMLYUjmQ&s" height="80" width="80" class="rounded">
                                                </div>

                                                <div><label><strong>Nome:</strong> {{ participante.nmParticipante }}</label></div>
                                                <div><label><strong>Como gosta de ser chamado:</strong> {{ participante.nmApelido }}</label></div>
                                                <div><label><strong>E-mail:</strong> {{ participante.dsEmail }}</label></div>
                                                <div><label><strong>Celular:</strong> {{ participante.nrCelular }}</label></div>
                                                <div><label><strong>CPF:</strong> {{ participante.nrCpf }}</label></div>
                                                <div><label><strong>RG:</strong> {{ participante.nrRg }}</label></div>



                                                <!--<div class="checkbox mt-3">
                                            <label>-->
                                                <!--@p_flConfirmado onchange="MudarPresencaConfirmada(@cont,@itemPassaporte.idParticipante);"-->
                                                <!--<input type="checkbox" id="flConfirmado_@cont-@itemPassaporte.idParticipante" name="" /> Presença confirmada
                                                </label>
                                            </div>

                                            <p v-id="participante.flConfirmado == 'Sim'">(Confirmado em: <strong>{{ participante.dtConfirmacao }}</strong> por: <strong>{{ participante.dsLoginConfirmacao }}</strong>)</p>-->

                                                <div class="mt-2">
                                                    <span class="span-informacao up" v-if="participante.flSelecaoOficina == 'Sim'">
                                                        <i class="far fa-thumbs-up"></i> Oficinas Selecionadas
                                                    </span>
                                                    <span class="span-informacao down" onclick="noDobleClick(this); " v-else>
                                                        <i class="fas fa-thumbs-down"></i> Oficinas Não Selecionadas
                                                    </span>
                                                </div>

                                                <!--enviaEmailOficina('@itemPassaporte.nmParticipante', '@itemPassaporte.dsEmail', 'Cadastro de Oficinas - @itemPassaporte.cdPassaporte', @itemPassaporte.idInscricao, @itemPassaporte.idParticipante, '');-->



                                                <div class="linha-cinza" style="margin-top: 10px; margin-bottom:0px;"></div>
                                            </div>
                                        </li>
                                    </ul>

                                </div>
                            </div>
                        </template>
                    </Card_Title>
                </div>
            </div>
        </div>

        <modal-warper target="Inscricao_Crud" :show="isOpenModalInscricaoCrud" @close="(isOpenModalInscricaoCrud = false)">
            <Inscricao_Crud :idOcorrencia="idOcorrencia" :idInstituicao="idInstituicao" :show="isOpenModalInscricaoCrud" @GetOcorrenciaInscricoes="GetOcorrenciaInscricoes" />
        </modal-warper>

        <modal-warper target="ModalConfirmacao_envia_email" :show="isOpenModalConfirmacaoEnviaEmail" @close="(isOpenModalConfirmacaoEnviaEmail = false)">
            <ModalConfirmacao id="envia_email" :title="'Deseja realmente enviar o email?'" :show="isOpenModalConfirmacaoEnviaEmail" :isDelete="false"
                              :description="'E-mail do Responsável: ' + dsEmailResponsavelEmail" :red="''" :action="'Enviar Email'" @actionReturn="EnviaEmailInscricao" />
        </modal-warper>

        <!--<modal-warper target="ModalConfirmacao_altera_proposta" :show="isOpenModalConfirmacaoAlteraProposta" @close="(isOpenModalConfirmacaoAlteraProposta = false)">
            <ModalConfirmacao id="altera_proposta" :title="'Deseja realmente alterar a proposta?'" :show="isOpenModalConfirmacaoAlteraProposta" :isDelete="false"
                              :description="''" :red="''" :action="'Alterar Proposta'" @actionReturn="AlteraProposta" />
        </modal-warper>-->

    </div>
</template>
<script>

    import axios from 'axios';
    import ModalWarper from '@/components/App/ModalWarper.vue'
    import OcorrenciaInfo from '@/components/Tickets/Ocorrencia/Ocorrencia_Info.vue'
    import Inscricao_Crud from '@/views/Modais/Ocorrencia/Modais/Inscricao_Crud.vue'
    import ModalConfirmacao from '@/components/App/ModalConfirmacao.vue'
    import Card_Title from '@/components/App/Card_Title.vue';
    import InputSearch from "@/components/App/Input_Search.vue";

    export default {
        name: 'Inscricao',
        components: {
            ModalWarper,
            OcorrenciaInfo,
            Inscricao_Crud,
            ModalConfirmacao,
            Card_Title,
            InputSearch
        },
        props: {
            idOcorrencia: {
                type: Number,
                default: 0
            },
        },
        data() {
            return {
                filtro_text: '',
                permissoes: { flAdministrador: 'Não', flGestorNovos: 'Não', flGestorRenovacao: 'Não', flGestorSucessoCliente: 'Não' },

                ocorrencia: {},
                idInsttiuicao: 0,

                NotLoading: false,
                idProposta: 0,

                isOpenModalInscricaoCrud: false,
                isOpenModalConfirmacaoEnviaEmail: false,
                Crud_IniciarProposta: {
                    idOcorrencia: 0
                },

                /*                isOpenModalConfirmacaoAlteraProposta: false,*/

                idModulo: 0,
                widthCustom: '',
                customHeigthNoPagDinamic: '',
                customHeigthHasPagDinamic: '',
                customWidthHasPagDinamic: '',

                inscricoes: [],

                idInscricaoEmail: 0,
                dsEmailResponsavelEmail: '',
                /*propostas: [],*/
                /*altera_proposta_crud: { idInscricao: 0, idProposta: 0 }*/
            }
        },
        computed: {},
        methods: {
            getOcorrencia() {
                let $this = this;
                axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Ocorrencia/GetId?id=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenComercial()
                }).then(response => {
                    $this.ocorrencia = response.data.data;
                    $this.idInstituicao = $this.ocorrencia.idInstituicao;
                })
            },
            //ConfirmaAlteraProposta(_idInscricao, _idProposta) {
            //    this.altera_proposta_crud = { idInscricao: 0, idProposta: 0 };
            //    this.altera_proposta_crud = { idInscricao: _idInscricao, idProposta: _idProposta };
            //    this.isOpenModalConfirmacaoAlteraProposta = true;
            //},
            //AlteraProposta() {
            //    let $this = this;

            //    axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/AlteraProposta', $this.altera_proposta_crud, { headers: $this.$api.getTokenEventos() })
            //        .then(function (response) {
            //            $this.GetOcorrenciaInscricoes();
            //            $this.$toast.show('success', 'Proposta alterada com sucesso.', true);
            //        })
            //        .catch(function (error) {
            //            var msg = 'Ocorreu um erro inesperado';
            //            if (error.response) {
            //                if (error.response.data.erros != '') {
            //                    msg = error.response.data.errors[0];
            //                } else {
            //                    msg = error.response.data.msg;
            //                }
            //            }
            //            $this.$toast.show('alert', msg, true);
            //        })
            //},
            getFiltros() {

            },
            performSearch() {
                this.getFiltros();
            },
            //GetPropostasProcessoInscricao() {
            //    let $this = this;
            //    axios.get(process.env.VUE_APP_ROOT_COMERCIAL_API + '/Proposta/GetPropostasProcessoInscricao?idOcorrencia=' + $this.idOcorrencia, {
            //        headers: $this.$api.getTokenComercial(),
            //        params: ''
            //    }).then(response => {
            //        $this.propostas = response.data.data;

            //    });
            //},
            ConfirmaEnviaEmailInscricao(_idInscricao, _dsEmailResponsavel) {
                this.idInscricaoEmail = _idInscricao;
                this.dsEmailResponsavelEmail = _dsEmailResponsavel;
                this.isOpenModalConfirmacaoEnviaEmail = true;
            },
            EnviaEmailInscricao() {
                let $this = this;
                var request = { idInscricao: $this.idInscricaoEmail };
                axios.post(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/EnviaEmail', request, { headers: $this.$api.getTokenEventos() })
                    .then(function (response) {
                        $this.idInscricaoEmail = 0;
                        this.dsEmailResponsavelEmail = '';
                        $this.$toast.show('success', 'E-mail enviado com sucesso.', true);
                    })
                    .catch(function (error) {
                        var msg = 'Ocorreu um erro inesperado';
                        if (error.response) {
                            if (error.response.data.erros != '') {
                                msg = error.response.data.errors[0];
                            } else {
                                msg = error.response.data.msg;
                            }
                        }
                        $this.idInscricaoEmail = 0;
                        this.dsEmailResponsavelEmail = '';
                        $this.$toast.show('alert', msg, true);
                    });
            },
            newLocalizador() {
                let $this = this;
                $this.isOpenModalInscricaoCrud = true;
            },
            GetOcorrenciaInscricoes() {
                let $this = this;

                axios.get(process.env.VUE_APP_ROOT_EVENTOS_API + '/Inscricao/GetOcorrenciaInscricoes?idOcorrencia=' + $this.idOcorrencia, {
                    headers: $this.$api.getTokenEventos(),
                    params: ''
                }).then(response => {
                    $this.inscricoes = response.data.data;
                })
            },

            fecharModal() {
                this.zerarInformacoes();
            },

            setActionCard(action) {
                this.$emit('setActionCard', action);
            },

        },
        created() {
        },
        mounted() {
            /*this.GetPropostasProcessoInscricao();*/
            this.getOcorrencia();
            this.GetOcorrenciaInscricoes();
        },
        updated() {
        },
        watch: {
            idOcorrencia(newVal, oldVal) {

            },
        },
    }

</script>

<style scoped lang="scss">
    .participantes .list-group li {
        font-size: 14px;
        padding: 10px 15px;
        height: auto;
        line-height: 21px;
    }

    #divQtdParticipantes {
        width: 150px;
        float: left;
        margin-bottom: 15px;
    }

    #retornoQtdParticipantes {
        display: inline-block;
        margin-bottom: 15px;
        line-height: 34px;
    }

    .span-informacao {
        display: inline-block;
        color: #fff;
        padding: 4px 10px;
        border-radius: 4px;
    }

    .span-informacao.up {
        background: #398439;
    }

    .span-informacao.down {
        background: #d9534f;
    }

    .span-informacao.down:hover {
        background: #d2332f;
        cursor: pointer;
    }
</style>